import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import api from '../services/api';

function Registro() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    nome_empresa: '',
    nome: '',
    email: '',
    senha: '',
    confirmar_senha: '',
  });
  const [showSenha, setShowSenha] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const set = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.senha !== form.confirmar_senha) {
      setError('As senhas não conferem.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const res = await api.post('/registrar/', form);
      const d = res.data;
      localStorage.setItem('access_token',   d.access);
      localStorage.setItem('refresh_token',  d.refresh);
      localStorage.setItem('first_name',     d.first_name || '');
      localStorage.setItem('last_name',      d.last_name  || '');
      localStorage.setItem('username',       d.username   || '');
      localStorage.setItem('is_staff',       String(d.is_staff ?? false));
      localStorage.setItem('is_superuser',   String(d.is_superuser ?? false));
      if (d.trial_expira_em) localStorage.setItem('trial_expira_em', d.trial_expira_em);
      if (d.plano)           localStorage.setItem('plano', d.plano);
      window.location.href = '/dashboard';
    } catch (err) {
      const data = err.response?.data;
      if (typeof data === 'object') {
        const msgs = Object.values(data).flat().join(' ');
        setError(msgs || 'Erro ao criar sua conta.');
      } else {
        setError('Erro ao criar sua conta. Tente novamente.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-bg">
      <div className="login-glow login-glow-1" />
      <div className="login-glow login-glow-2" />

      <main className="login-main">
        <div className="login-card" style={{ maxWidth: 480 }}>
          <div className="login-card-accent" />

          <div className="login-card-body">
            <div className="login-logo-wrap">
              <img src="/logo_hope.png" alt="Hope System" className="login-logo-img" />
            </div>

            <div className="login-header">
              <h1 className="login-title">Comece gratuitamente</h1>
              <p className="login-subtitle">14 dias grátis, sem cartão de crédito.</p>
            </div>

            {error && (
              <div className="login-error">
                <span className="material-symbols-outlined">error</span>
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="login-form">
              <div className="login-field">
                <label className="login-label">Nome da Empresa</label>
                <div className="login-input-wrap">
                  <span className="material-symbols-outlined login-input-icon">business</span>
                  <input
                    className="login-input"
                    type="text"
                    placeholder="Ex: Vidraçaria Modelo"
                    value={form.nome_empresa}
                    onChange={set('nome_empresa')}
                    required
                  />
                </div>
              </div>

              <div className="login-field">
                <label className="login-label">Seu nome</label>
                <div className="login-input-wrap">
                  <span className="material-symbols-outlined login-input-icon">person</span>
                  <input
                    className="login-input"
                    type="text"
                    placeholder="Nome e sobrenome"
                    value={form.nome}
                    onChange={set('nome')}
                  />
                </div>
              </div>

              <div className="login-field">
                <label className="login-label">E-mail</label>
                <div className="login-input-wrap">
                  <span className="material-symbols-outlined login-input-icon">email</span>
                  <input
                    className="login-input"
                    type="email"
                    placeholder="voce@empresa.com"
                    value={form.email}
                    onChange={set('email')}
                    required
                  />
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <div className="login-field">
                  <label className="login-label">Senha</label>
                  <div className="login-input-wrap">
                    <span className="material-symbols-outlined login-input-icon">lock</span>
                    <input
                      className="login-input login-input-password"
                      type={showSenha ? 'text' : 'password'}
                      placeholder="Mín. 8 caracteres"
                      value={form.senha}
                      onChange={set('senha')}
                      required
                      minLength={8}
                    />
                    <button
                      type="button"
                      className="login-toggle-pw"
                      onClick={() => setShowSenha(!showSenha)}
                    >
                      <span className="material-symbols-outlined">
                        {showSenha ? 'visibility_off' : 'visibility'}
                      </span>
                    </button>
                  </div>
                </div>

                <div className="login-field">
                  <label className="login-label">Confirmar senha</label>
                  <div className="login-input-wrap">
                    <span className="material-symbols-outlined login-input-icon">lock_reset</span>
                    <input
                      className="login-input"
                      type={showSenha ? 'text' : 'password'}
                      placeholder="Repita a senha"
                      value={form.confirmar_senha}
                      onChange={set('confirmar_senha')}
                      required
                      minLength={8}
                    />
                  </div>
                </div>
              </div>

              <button type="submit" className="login-btn" disabled={loading}>
                {loading ? 'Criando sua conta...' : (
                  <>
                    Criar conta grátis
                    <span className="material-symbols-outlined">rocket_launch</span>
                  </>
                )}
              </button>
            </form>
          </div>

          <div className="login-card-footer">
            <p>
              Já tem uma conta?{' '}
              <a href="/login" onClick={(e) => { e.preventDefault(); navigate('/login'); }}>
                Faça login
              </a>
            </p>
          </div>
        </div>

        <footer className="login-footer">
          <p className="login-slogan">Tecnologia. Confiança. Resultados.</p>
          <p className="login-copy">© 2024 Hope System Corporate. Todos os direitos reservados.</p>
        </footer>
      </main>
    </div>
  );
}

export default Registro;
